import React, { Component } from 'react'
import { Modal, message, Table, Row, Icon } from "antd"
import Store from 'app/stores/research/pgs/report'
import { Provider, observer, inject } from 'mobx-react'
import { Route } from 'react-router-dom'
import config from "app/config"
import ReportDetail from "app/components/normal/pgs/ReportDetail"
import cx from "classnames"
import FlexableFileName from "app/components/normal/FlexableFileName"
import { PREPARE_RUN, RUNNING, SUCCESS, FAIL } from 'app/utils/const'

@inject('reportStore', 'entrance') @observer
export default class DataTable extends Component {
  constructor(props) {
    super(props)
    this.store = Store.fromJS()
    this.state = {
      currentPageIndex: 1,
      totalCount: 0,
      dataIndex: 0,
      reportGroupData: {},
    }
  }
  componentDidMount() {
    const { location } = this.props
    const { initTableData, updateTableData } = this.props.reportStore
    initTableData()
      .then(
        res => {
          updateTableData(res)
          const pathArr = location.pathname.split('/')
          const reportId = pathArr.slice(-1)[0]
          if (pathArr.slice(-2)[0] === 'detail') {
            this.initDetailData(reportId)
          }
        },
        err => {
          message.error(err.message)
        }
      )
  }

  initDetailData = (reportId) => {
    const { getDetailData, tableData, clearDetailData } = this.props.reportStore
    const index = tableData.reportList.findIndex(report => report.reportId === reportId)
    if (index > -1) {
      clearDetailData()
      this.setState({
        dataIndex: index,
        reportGroupData: tableData
      })
      getDetailData(reportId)
    }
  }

  openDetail = (data, record) => {
    let { getDetailData, clearDetailData } = this.props.reportStore
    let { history, match } = this.props

    const index = data.reportList.findIndex(report =>
      report.reportId === record.reportId
    )

    clearDetailData()

    this.setState({
      dataIndex: index,
      reportGroupData: data
    })
    let reportId = data.reportList[index].reportId
    getDetailData(reportId)
      .then(res => {
        record.isRead = true
      })
    history.push({
      pathname: `${match.url}/detail/${reportId}`,
    })
  }
  checkOperatable = (record) => {
    return record.state === SUCCESS
  }

  dataSwitch = (index, record) => {
    let { getDetailData, clearDetailData } = this.props.reportStore
    clearDetailData()
    this.setState({
      dataIndex: index,
    })
    getDetailData(record.reportId)
      .then(res => {
        record.isRead = true
      })
  }

  copyText = (content) => {
    let targetId = "_hiddenCopyText_"
    let currentFocus = document.activeElement
    let target = document.getElementById(targetId)
    currentFocus.focus()

    // 如果不是，则使用节点的textContent
    if (!target) {
      //如果不存在，则创建一个
      target = document.createElement("textarea")
      target.style.position = "absolute"
      target.style.left = "-9999px"
      target.style.top = "0"
      target.id = targetId
      document.body.appendChild(target)
    }
    target.textContent = content
    // 聚焦目标节点，选中它的内容
    target.focus()
    target.setSelectionRange(0, target.value.length)

    // 进行复制操作
    try {
      document.execCommand("copy")
      message.success("复制链接成功")
    } catch (e) {
      message.error("复制链接失败")
    }

    // 不再聚焦
    if (currentFocus && typeof currentFocus.focus === "function") {
      currentFocus.focus()
    }

    // 清空临时数据
    target.textContent = ""
  }

  render() {
    const { tableData, detailData } = this.props.reportStore
    const { match, history, entrance } = this.props
    const { reportGroupData, dataIndex } = this.state
    const renderContent = (text, record, index) => {
      const obj = {
        children: text,
        props: {},
      }

      if (record.state === PREPARE_RUN || record.state === RUNNING || record.state === FAIL) {
        obj.props.colSpan = 0
      }
      return obj
    }

    this.columns = [
      {
        title: (
          <div className="unread-table-column dib">
            文件名称
          </div>
        ),
        dataIndex: "filename",
        render: (text, record, index) => {
          const operatable = this.checkOperatable(record)
          const filenameClass = cx({
            "unread-table-column filename blue-text2": true,
            "unread-message": record.isRead === false,    // api好了改逻辑
            disable: !operatable,
            "cursor-p": operatable
          })
          return (
            <div className={filenameClass} onClick={operatable && (() => this.openDetail(tableData, record))}>
              {
                !record.isRead && (<div className="unread-icon"></div>)
              }
              <FlexableFileName filename={text} isEqual={true} />
            </div>
          )
        }
      }, {
        width: "10.71%",
        title: "样本名称",
        dataIndex: "sampleName",
        render: (text) => {
          return (
            <div>{text}</div>
          )
        }
      }, {
        title: "Total_Reads",
        className: "ta-l",
        dataIndex: "totalReads",
        render: (text, record, index) => {
          const stateData = [
            {
              text: "数据准备运行",
              className: "pre-run pgs-state-element"
            },
            {
              text: "数据正在运行",
              className: "running pgs-state-element"
            },
          ]
          switch (record.state) {
            case PREPARE_RUN:
              return {
                children: (
                  <Row type="flex" justify="center" align="middle">
                    <div className={stateData[0].className}>
                      <Icon type="hourglass" />
                      {stateData[0].text}
                    </div>
                  </Row>
                ),
                props: {
                  colSpan: 7
                }
              }
            case RUNNING:
              return {
                children: (
                  <Row type="flex" justify="center" align="middle">
                    <div className={stateData[1].className}>
                      <Icon type="clock-circle-o" />
                      {stateData[1].text}
                    </div>
                  </Row>
                ),
                props: {
                  colSpan: 7
                }
              }
            case FAIL:
              return {
                children: (
                  <Row type="flex" justify="center">
                    <div className="pgs-state-element run-failed">
                      <Icon type="close-circle" />
                      数据运行失败，
                      <div className="failed-button" onClick={() => this.copyText(record.reportId)}>
                        点击复制错误信息
                      </div>
                      发送给管理员，将尽快为您解决问题。
                      <a
                        href={`${config.backend}/pgs/reports/${record.reportId}/download`}
                        title="下载报告"
                        className="failed-download"
                      >
                        点击下载报告结果压缩包
                      </a>
                    </div>
                  </Row>
                ),
                props: {
                  colSpan: 7
                }
              }
            case SUCCESS:
              return (<div>{text}</div>)
            default:
              return (<div>{text}</div>)
          }
        }
      }, {
        title: "MT_ratio(%)",
        className: "ta-l",
        dataIndex: "mtRatio",
        render: renderContent
      }, {
        title: "Map_Ratio(%)",
        className: "ta-l",
        dataIndex: "mapRatio",
        render: renderContent
      }, {
        title: "Duplicate(%)",
        className: "ta-l",
        dataIndex: "duplicate",
        render: renderContent
      }, {
        title: "Unique_Reads",
        className: "ta-l",
        dataIndex: "uniqueReads",
        render: (text) => {
          return (
            <div>{text || '-'}</div>
          )
        }
      }, {
        title: "GC_Count(%)",
        className: "ta-l",
        dataIndex: "gcCount",
        render: renderContent
      }, {
        title: "*SD",
        className: "ta-l",
        dataIndex: "sd",
        render: renderContent
      }, {
        title: "基线版本",
        classNames: "ta-l",
        dataIndex: "version",
        render: renderContent
      }
    ]
    return (
      <Provider store={this.store}>
        <div>
          <div className='wrapper-box'>
            <div>
              <Table
                className="pgd-datamanage-table"
                columns={this.columns}
                dataSource={tableData.reportList && tableData.reportList.slice()}
                rowKey={record => record.reportId}
                pagination={false}
              />
            </div>
          </div>
          {/* 报告详情modal */}
          <Route
            path={`${match.url}/detail/:id`}
            render={() => {
              return (
                <Modal
                  title="报告详情"
                  width={1172}
                  footer={0}
                  maskClosable={false}
                  visible={true}
                  onCancel={history.goBack}
                  className="detail-modal"
                >
                  <ReportDetail
                    data={reportGroupData}
                    index={dataIndex}
                    detailData={detailData}
                    reportList={reportGroupData.reportList}
                    templates={entrance.templates}
                    dataSwitch={this.dataSwitch}
                    store={this.store}
                    groupId={reportGroupData.groupId}
                  />
                </Modal>
              )
            }}
          />
        </div>

      </Provider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/research/pgs/data_manage_detail/containers/DataTable.js